import { render, staticRenderFns } from "./livePanel.vue?vue&type=template&id=4c879ddb&scoped=true"
import script from "./livePanel.vue?vue&type=script&lang=js"
export * from "./livePanel.vue?vue&type=script&lang=js"
import style0 from "./livePanel.vue?vue&type=style&index=0&id=4c879ddb&prod&lang=less&scoped=true"
import style1 from "./livePanel.vue?vue&type=style&index=1&id=4c879ddb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c879ddb",
  null
  
)

export default component.exports